<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/scheduling-software-for-consultants.mjs";
</script>
